import {BACKEND} from '../../consts/backend';

const Getbs = async () => {
  var requestOptions = {
    method: 'GET',
    redirect: 'follow',
  };

  const resp = await fetch(`${BACKEND}/bs`, requestOptions);
  const sku = await resp.json();

  return sku;
};

export default Getbs;
